var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_353_1052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0634766,
    y: 0.0625,
    width: 30.7394,
    height: 30.0318,
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_353_1052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46738 26.3404C5.76294 26.3404 5.15967 26.0955 4.6576 25.6058C4.15637 25.1153 3.90576 24.5259 3.90576 23.8377V6.31918C3.90576 5.63095 4.15637 5.04157 4.6576 4.55106C5.15967 4.06137 5.76294 3.81653 6.46738 3.81653H15.4331V6.31918H6.46738V23.8377H15.4331V26.3404H6.46738ZM20.5563 21.3351L18.7952 19.5206L22.0612 16.3298H11.5906V13.8271H22.0612L18.7952 10.6362L20.5563 8.82183L26.9603 15.0784L20.5563 21.3351Z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutNew);
export default __webpack_public_path__ + "static/media/logoutNew.5122650e774e917d01cd9c55a71e6c2b.svg";
export { ForwardRef as ReactComponent };